import { useQueryParam } from '@occc-app/hooks/useQueryParam';
import { deletePaginationParams } from '@occc-app/hooks/usePaginationParams';

import { StatusType } from '../types';
import { AUDIENCE_STATUS_ALL } from '../constants';

export const useAudiencesFilterStatus = (
  statusParamName: string,
  beforeParam?: string,
  afterParam?: string,
) => {
  return useQueryParam<StatusType>(
    (searchParams) => {
      const status = searchParams.get(statusParamName) || undefined;
      return status as StatusType;
    },
    (value, searchParams) => {
      if (value && value !== AUDIENCE_STATUS_ALL) {
        searchParams.set(statusParamName, value);
      } else {
        searchParams.delete(statusParamName);
      }

      deletePaginationParams(searchParams, beforeParam, afterParam);
    },
  );
};
